document.addEventListener('DOMContentLoaded', function() {
    const header = document.getElementById('peUpsellHeader');
    const toggle = document.getElementById('peUpsellToggle');
    const content = document.getElementById('peUpsellContent');
    const checkboxes = document.querySelectorAll('.pe-upsell-checkbox input');
    const totalPriceElement = document.querySelector('.pe-total-price');
    const extrasTotalPriceElement = document.querySelector('.pe-extras-total-price-amount');

    toggle.classList.add('collapsed');

    header.addEventListener('click', function() {
        toggle.classList.toggle('collapsed');
        content.classList.toggle('expanded');
    });

    checkboxes.forEach(function(checkbox) {
        checkbox.addEventListener('change', function() {
            const item = document.querySelector(`label[for="${checkbox.id}"]`);

            if (this.checked) {
                item.classList.add('pe-checked');
            } else {
                item.classList.remove('pe-checked');
            }

            updateTotalPrice();
            updateExtrasTotalPrice();
        });
    });

    checkboxes.forEach(function(checkbox) {
        if (checkbox.checked) {
            const item = document.querySelector(`label[for="${checkbox.id}"]`);
            item.classList.add('pe-checked');
        }
    });

    function parsePrice(value) {
        if (!value) return 0;
        return parseFloat(value.replace(/[^0-9.]/g, '')) || 0;
    }

    function formatMoney(value) {
        const number = Number(value) || 0;
        const hasDecimals = number % 1 !== 0;

        return '$' + number.toLocaleString('en-US', {
            minimumFractionDigits: hasDecimals ? 2 : 0,
            maximumFractionDigits: hasDecimals ? 2 : 0
        });
    }

    function updateTotalPrice() {
        let total = 0;

        checkboxes.forEach(function(checkbox) {
            if (checkbox.checked) {
                const item = document.querySelector(`label[for="${checkbox.id}"]`);
                const price = parsePrice(item.dataset.price);
                total += price;
            }
        });

        totalPriceElement.textContent = formatMoney(total);
        return total;
    }

    function getBasePrice() {
        const basePriceElement = document.querySelector('.price__sale-current');
        if (!basePriceElement) return 0;

        return parsePrice(basePriceElement.textContent);
    }

    function updateExtrasTotalPrice() {
        const upsellTotal = updateTotalPrice();
        const basePrice = getBasePrice();
        const combinedTotal = upsellTotal + basePrice;

        if (extrasTotalPriceElement) {
            extrasTotalPriceElement.textContent = formatMoney(combinedTotal);
        }
    }

    function initializeExtrasTotalPrice() {
        const basePrice = getBasePrice();

        if (extrasTotalPriceElement) {
            extrasTotalPriceElement.textContent = formatMoney(basePrice);
        }
    }

    updateTotalPrice();
    initializeExtrasTotalPrice();
});